// 状态码
export enum SDKStatusCode {
  // 错误
  Error = -1,
  // 成功
  Success = 10000,
  // 不支持环境
  NoSupport = 10001,
  // 未初始化
  NoInit = 10002,
  // 未登录
  NoLogin = 10003,
  // 渠道配置错误
  ChannelConfigError = 10004,
  // 聚合订单错误
  AggregateOrderError = 10005,
  // 订单回调错误
  OrderNotifyError = 10006,
  // 预创建订单错误
  PresetOrderError = 10007,
  // 扫码订单错误
  ScanCodeOrderError = 10008,
  // 账号支付异常错误
  AccountExceptionError = 10009,
  // 设备支付异常错误
  DeviceExceptionError = 10010,
  // 账号创单异常错误
  CreateExceptionError = 10011,
  // 获取账号协议配置错误
  ClauseConfigError = 10012,
  // 生成图形验证码错误
  GenerateCaptchaError = 10013,
  // 发送短信验证码错误
  SendVerifyCodeError = 10014,
  // 发送短信限制错误
  SendVerifyLimitError = 10015,
  // 验证短信验证码错误
  VerifyInputCodeError = 10016,
  // 获取用户信息错误
  GetUserInfoError = 10017,
  // 微信授权失败
  WechatAuthorizeError = 100018,
  // 登录失败
  LoginError = 20001,
  // 注销冷静期
  LoginFreezeError = 20002,
  // 登录取消
  LoginCancelError = 20003,
  // 登录授权
  LoginAuthorizeError = 20004,
  // 支付失败
  PayError = 30001,
  // 支付关闭
  PayCloseError = 30002,
  // 游戏币支付失败
  PayGameCurrencyError = 30003,
  // 道具直购失败
  PayGoodsDirectError = 30004,
  // 客服取消支付
  PayServiceCancelError = 30005,
  // 客服支付失败
  PayServiceError = 30006,
  // 扫码支付失败
  PayScanCodeError = 30007,
  // 注销冷静期
  PayAccountFreezeError = 30008,
  // 道具直购取消
  PayGoodsDirectCancelError = 30009,
  // 游戏币支付取消
  PayGameCurrencyCancelError = 30010,
  // 不支持支付方式
  PayNoSupportError = 30011,
  // 浏览器不支持支付
  PayNoSupportBrowserError = 30012,
  // 账号登录过期
  PayAccountExpiredError = 30013,
  // 防沉迷支付限制
  PayAntiAddictionError = 30014,
  // 支付订单过期
  PayOrderExpireError = 30015,
  // 广告失败
  AdError = 40001,
  // 视频广告失败
  RewardedVideoAdError = 40002,
  // 横幅广告失败
  BannerAdError = 40003,
  // 插屏广告失败
  InterstitialAdError = 40004,
  // 自定义广告失败
  CustomAdError = 40005,
  // 问卷失败
  SurveyError = 50001,
  // 问卷取消
  SurveyCancelError = 50002,
  // 订阅消息失败
  SubscribeMessageError = 60001,
  // 订阅上报失败
  SubscribeMessageReportError = 60002,
  // 转发失败
  ShareAppMessageError = 70001,
  // 显示转发菜单失败
  ShowShareMenuError = 70002,
  // 隐藏转发菜单失败
  HideShareMenuError = 70003,
  // 转发卡片失败
  ShareMessageCardError = 70004,
  // 绑定被动转发失败
  OnShareAppMessageError = 70005,
  // 解绑被动转发失败
  OffShareAppMessageError = 70006,
  // 客服失败
  ServiceError = 80001,
  // 客服取消
  ServiceCancelError = 80002,
  // 客服链接失败
  ServiceLinkError = 80003,
  // 桌面快捷方式
  ShortcutError = 90001,
  // 桌面快捷方式授权
  ShortcutAuthError = 90002,
  // 侧边栏失败
  SidebarError = 100001,
  // 游戏直播失败
  GameLiveError = 110001,
  // 游戏圈失败
  GameClubError = 120001,
  // 游戏中心失败
  GameCenterError = 130001,
  // 上报日志失败
  TrackLogError = 140001,
  // 推荐流直玩订阅失败
  FeedSubscribeError = 150001,
}

// 支付方式
export enum SDKPayType {
  // 内购
  Native = 1,
  // 客服
  Service = 2,
  // 扫码
  QRCode = 3,
  // 浏览器
  Browser = 4,
}

// 缓存Key
export enum SDKStorageKey {
  // 用户信息
  UserInfo = "NEBULA_SDK_CORE_USER_INFO_V20260715",
  // 设备ID
  DeviceId = "NEBULA_SDK_CORE_DEVICE_ID_V20260715",
  // 通知队列
  NotifyQueue = "NEBULA_SDK_CORE_NOTIFY_LIST_V20260715",
  // 日志队列
  TrackQueue = "NEBULA_SDK_CORE_TRACK_LIST_V20260715",
}

// 运行环境
export enum SDKEnv {
  // 浏览器
  Web = "webminigame",
  // 美团
  MeiTuan = "meituanminigame",
  // 微信
  Wechat = "wechatminigame",
  // 抖音
  DouYin = "douyinminigame",
  // 支付宝
  AliPay = "alipayminigame",
  // 淘宝
  TaoBao = "taobaominigame",
  // 快手
  KuaiShou = "kuaishouminigame",
  // 京东
  JingdDong = "jingdongminigame",
  // 哔哩哔哩
  BiliBili = "bilibiliminigame",
  // 小米
  XiaoMi = "xiaomiminigame",
  // OPPO
  OPPO = "oppominigame",
  // VIVO
  VIVO = "vivominigame",
  // 华为
  HuaWei = "huaweiminigame",
  // 荣耀
  Honor = "honorminigame",
  // TikTok
  GlobalTikTok = "globaltiktokminigame",
  // 未知
  Unknown = "unknown",
}

// 运行平台
export enum SDKPlatform {
  // 安卓
  Android = "android",
  // 开发者工具
  Devtools = "devtools",
  // iOS
  IOS = "ios",
  // Mac
  Mac = "mac",
  // 鸿蒙
  Harmony = "ohos",
  // Windows
  Windows = "windows",
  // 未知
  Unknown = "unknown",
}
